import React from 'react';

import MetricBox from './MetricBox';

interface FlightTimeElapsedProps {
  seconds: number;
}

const format = (seconds: number): string => {
  const h = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, '0');
  const m = Math.floor((seconds % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, '0');
  return `${h}:${m}:${s}`;
};

const FlightTimeElapsed: React.FC<FlightTimeElapsedProps> = ({ seconds }) => (
  <MetricBox label='Flight Time Elapsed' value={format(seconds)} />
);

export default FlightTimeElapsed;
